import React, { useEffect, useMemo, useState } from "react";
import { Modal } from "react-bootstrap";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import * as actions from "../../../_redux/neighbourhood/customersActions";
import * as cityActions from  "../../../_redux/city/cityAction";
import * as countryActions from  "../../../_redux/country/countryAction";
import { CustomerEditDialogHeader } from "./CustomerEditDialogHeader";
import { CustomerEditForm } from "./CustomerEditForm";
import { useCustomersUIContext } from "../CustomersUIContext";
import { listCity,listCountry } from "../../../_redux/city/cityCrud";

export function CustomerEditDialog({ id, show, onHide}) {
 
  // Customers UI Context
  const customersUIContext = useCustomersUIContext();
  const customersUIProps = useMemo(() => {
    return {
      initCustomer: customersUIContext.initCustomer,
    };
  }, [customersUIContext]);

  // Customers Redux state
  const dispatch = useDispatch();
  const { actionsLoading, customerForEdit,customerForArea,data} = useSelector(
    (state) => ({
      actionsLoading: state.customers.actionsLoading,
      customerForEdit: state.customers.customerForEdit,
      customerForArea: state.customers.customerForArea,
    }),
    shallowEqual
  );
const [countries,setCountries]=useState([]);
const [cities,setCities]=useState([])
  useEffect(() => {
    if(!countries.length){
      listCountry().then(result=>{
        setCountries([...result.data.data]);
  
      })
     
    }
    if(!cities.length&&countries.length){
      
      listCity({countryId:countries[0]._id}).then(result=>{
        setCities([...result.data.data]);
  
      })
    }
    

  }, [id, dispatch,countries,cities]);
  // server request for saving customer
  const saveCustomer = (customer) => {

    if (!id) {
      // server request for creating customer
      dispatch(actions.createCustomer(customer)).then(() => onHide());
    } else {
      // server request for updating customer
      dispatch(actions.updateCustomer(customer)).then(() => onHide());
    }
  };

  return (
    <Modal
      size="lg"
      show={show}
      onHide={onHide}
      aria-labelledby="example-modal-sizes-title-lg"
    >
      <CustomerEditDialogHeader id={id} />
      <CustomerEditForm
        saveCustomer={saveCustomer}
        actionsLoading={actionsLoading}
        customer={customerForEdit || customersUIProps.initCustomer}
        onHide={onHide}
        areas={customerForArea}
        countries={countries}
        citylist={cities}
        
      />
    </Modal>
  );
}
